module.exports = __webpack_public_path__ + "img/6.f0199d23.jpg";